import { client } from './client'

// data = { old_password, new_password, new_password2 }
export const changePasswordRequest = (data) => client.put('/user/password', data)
